<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import dayjs from "dayjs";
const customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "listMonth",
        key: "id",
        url: {
          list: "/admin/system/facilityPay/listMonth",
        },
        output: false,
        // order: "createTime",
      },
      query: {},
      actions: [],
      menus: [
        {
          label: "收费清单",
          name: "listOfCharges_list",
          auth: "",
        },
        {
          label: "费率",
          name: "rate_list",
          auth: "",
        },
      ],
      filters: [
        // {
        //   label: "盘点人",
        //   KeyEnter: this.search,
        //   name: "createBy",
        //   value: "",
        //   type: "input",
        // },
        // // {
        // //   label: "负责人",
        // //   KeyEnter: this.search,
        // //   name: "maintainerId",
        // //   value: "",
        // //   type: "select",
        // //   dropList: [],
        // // },
        // {
        //   label: "盘点时间",
        //   KeyEnter: this.search,
        //   name: "",
        //   value: "",
        //   type: "contractdatetimerange",
        // },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "内容",
          key: "payMonthTime",
          minWidth: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            let timeA = row.payMonthTime.slice(0, 7);
            let payMonthTime;
            if (timeA.split("-")[1] - 1 == 0) {
              payMonthTime = [timeA.split("-")[0] - 1, 12];
            } else {
              payMonthTime = [timeA.split("-")[0], timeA.split("-")[1] - 1];
            }
            const monthMoney = row.monthMoney;
            return (
              <div onClick={() => this.toinfo(row)}>
                <span>{payMonthTime.join("年")}月</span>
                <span
                  style={{
                    color: "#4991ff",
                    cursor: "pointer",
                    marginLeft: "10px",
                  }}
                >
                  {monthMoney}元
                </span>
              </div>
            );
          },
        },

        // {
        //     title: "总费用",
        //     key: "serviceMoney",
        //     minWidth: 200,
        //     align: "left",
        //     render: (h, params) => {
        //         const row = params.row;
        //         const text = row.monthMoney
        //         return (
        //             <span
        //             >
        //                 {text}元
        //             </span>
        //         );
        //     },
        // },
        // {
        //     title: "操作",
        //     align: "center",
        //     width: 210,
        //     key: "handle",
        //     fixed: "right",
        //     handle: [
        //         (vm, h, currentRow, param) => {
        //             // let directives = []
        //             return (
        //                 <Button
        //                     size="small"
        //                     onClick={() => this.toinfo(currentRow)}
        //                     type="default"
        //                     style={{
        //                         border: "none",
        //                         color: "#4991ff", margin: "0",
        //                     }}
        //                 >
        //                     详情
        //                 </Button>
        //             );
        //         },
        //     ],
        //     auth: {
        //         // edit: "system/knowledgeBaseTag/edit",
        //         // del: "system/inspection/delete",
        //     },
        // },
        // {
        //   title: "盘点人",
        //   key: "createBy",
        //   minWidth: 100,
        //   align: "left",
        // },
        // {
        //   title: "盘点时间",
        //   key: "createTime",
        //   minWidth: 120,
        //   align: "left",
        // },
      ],
    };
  },
  created() {
    this.query.customerId =
      Number(customerId) === 0
        ? window.localStorage.getItem("customerIdClick")
        : Number(customerId);
    /* if (Number(customerId) === 0) {
      this.tableCols.push({
        title: "操作",
        width: 120,
        align: "left",
        render: (h, params) => {
          const row = params.row;
          return (
            <div onClick={() => this.onEditA(row)}>
              <span
                style={{
                  color: "#4991ff",
                  cursor: "pointer",
                  marginLeft: "10px",
                }}
              >
                重新计算
              </span>
            </div>
          );
        },
      });
    } */
  },
  methods: {
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toAdd() {
      $utils.url.push({ name: "inspection_add", query: { action: "add" } });
    },
    toinfo(row) {
      $utils.url.push({
        name: "summarizing_list",
        query: { payMonthTime: row.payMonthTime },
      });
    },
    async onEditA(row) {
      console.log(row);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let begin = dayjs(row.payMonthTime).startOf("month").format("YYYY-MM-DD");
      let end = dayjs(row.payMonthTime).endOf("month").format("YYYY-MM-DD");
      let q = {
        customerId: window.localStorage.getItem("customerIdClick"),
        begin,
        end,
      };
      let res = await $utils.api.load(
        "/admin/system/facilityPay/flash",
        q,
        "post"
      );
      console.log(res);

      if (res.code == 200) {
        loading.close();
        console.log(res);
        $utils.toast.success(res.msg);
        this.search();
      } else {
        loading.close();
      }
    },
  },
};
</script>
<style scoped></style>
